import { cloudflareR2StorageProvider } from "@/services/storage/providers/cloudflareR2StorageProvider";
import { getRuntimeEnv } from "@/shared/storage-contracts";
import type { StorageProvider } from "@/services/storage/types";

export { getRuntimeEnv };

export const getBackendKey = (): string => "r2";

export const getStorageProviderByKey = (_backend: string): StorageProvider => cloudflareR2StorageProvider;

export const createStorageProvider = (): StorageProvider => cloudflareR2StorageProvider;
